<template>
  <div class="archived-badge">
    Archived
  </div>
</template>

<style lang="less" scoped>
.archived-badge {
  flex-shrink: 0;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  border: 1px solid @stroke-default;
  border-radius: 24px;
  font-size: 12px;
  font-weight: 500;
  color: @text-light;
}
</style>
